import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Input, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import { editEntityField, saveWebsite } from '../../../actions';
import { withRouter } from 'react-router-dom';

const languageOptions = ['he', 'en'];
const orderOptions = ['sitting', 'takeaway', 'delivery'];

class WebsiteEditor extends Component {
    handleSubmit = (event) => {
        this.props.saveWebsite(this.props.entity);
        event.preventDefault();
    }

    render() {
        const { entity } = this.props;

        const website = entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <Dropdown
                        fluid
                        required
                        selection
                        search
                        options={this.props.brands.map(value => ({ value, text: value }))}
                        value={website.brandKey || ''}
                        onChange={(e, { value }) => this.props.editEntityField('brandKey', value)}
                    />
                </Form.Field>

                <Form.Field>
                    <Dropdown
                        placeholder={i18next.t('general.languages')}
                        fluid
                        selection
                        multiple
                        options={languageOptions.map(value => ({ value, text: i18next.t('languages.' + value) }))}
                        value={website.languages || []}
                        onChange={(e, { value }) => this.props.editEntityField('languages', value)}
                    />
                </Form.Field>

                <Form.Field>
                    <Dropdown
                        placeholder={i18next.t('supportedOrderTypes')}
                        fluid
                        selection
                        multiple
                        options={orderOptions.map(value => ({ value, text: i18next.t(value) }))}
                        value={website.orderTypes || []}
                        onChange={(e, { value }) => this.props.editEntityField('orderTypes', value)}
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('supportTableNumberField')}
                        checked={!!website.supportTableNumberField}
                        onChange={(e, { checked }) => this.props.editEntityField('supportTableNumberField', checked)}
                    />
                </Form.Field>

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('suspended')}
                        checked={website.isDisabled}
                        onChange={(e, { checked }) => this.props.editEntityField('isDisabled', checked)}
                    />
                </Form.Field>

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

WebsiteEditor.propTypes = {
    saveWebsite: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object,
    brands: PropTypes.array,
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;
    const brands = state.businessApp.brands.map(b => b.key);

    return { entity, brands };
};

export default connect(mapStateToProps, {
    saveWebsite,
    editEntityField,
})(withRouter(WebsiteEditor));
